<section>
  <div class="row">
    <div class="col mt-0">
      <span class="current-num">{{currentQuestionNum | number:'2.0' }}</span><span class="total-qs">of
        {{totalQuestions | number:'2.0' }}</span>
    </div>
    <div class="col-12 ">
      <h4 class="m-t-10">{{currentQuestion?.question}}</h4>

      <ng-container *ngIf="!currentQuestion?.showInterests">
        <div class="row" *ngFor="let rep of currentQuestion?.responses; let i =index">
          <div *ngIf="currentQuestion?.isMultiSelect" class="col-12 rep-link"
            (click)="setAnswer(rep, currentQuestion, i, true)" [ngClass]="{active:responseSelected(rep.num, i)}">
            {{rep.response}}
          </div>
          <div *ngIf="!currentQuestion?.isMultiSelect" class="col-12 rep-link"
            (click)="setAnswer(rep, currentQuestion, i, false)" [ngClass]="{active:rep.num==currentResponse?.num}">
            {{rep.response}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="currentQuestion?.type=='dropdown'">
        <div class="row">
          <div class="col-6">
            <app-questionaire-dropdown [type]="currentQuestion?.valueType" [start]="currentQuestion?.start"
              [end]="currentQuestion?.end"
              (valSelected)="dropDownVal($event, currentQuestion)"></app-questionaire-dropdown>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="currentQuestion?.type=='radio'">
          <app-questionaire-radio [options]="currentQuestion?.values" (valSelected)="radioVal($event, currentQuestion)"></app-questionaire-radio>
        </ng-container>

      <ng-container *ngIf="currentQuestion?.showInterests">
        <section class="interest-section" *ngFor="let interest of interests; let i = index">
          <span class="interest-list-section">
            <mat-checkbox class="interest-margin" [checked]="allInterestsSelected[i]" [indeterminate]="someComplete(i)"
              (change)="setAll(i,$event.checked)">
              {{interest.interest}}
            </mat-checkbox>
          </span>
          <span class="interest-list-section">
            <ul>
              <li *ngFor="let focus of interest.focuses">
                <mat-checkbox [(ngModel)]="focus.selected" (ngModelChange)="updateAllComplete(i)">
                  {{focus.focus}}
                </mat-checkbox>
              </li>
            </ul>
          </span>
        </section>
      </ng-container>
    </div>
    <div class="col-12 d-flex justify-content-between">
      <div class="" *ngIf="currentQuestionNum==1">&nbsp;</div>
      <button class="btn bg-dol-green" *ngIf="currentQuestionNum>1" (click)="moveBack()">Back</button>
      <button class="btn bg-dol-green" *ngIf="currentQuestionNum<totalQuestions" (click)="moveForward()">Next</button>
      <button class="btn bg-dol-green" *ngIf="currentQuestionNum==totalQuestions" (click)="complete()">Complete</button>
    </div>
  </div>

  <div class="row d-flex justify-content-center">
    <div class="w-150">
      <div class="col-auto ">

      </div>
    </div>
  </div>
</section>
